// Central image registry for CLAX mock data
const U = (id, w = 800) => `https://images.unsplash.com/${id}?w=${w}&q=80&auto=format&fit=crop`;
const P = (id, w = 940) => `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&w=${w}`;

export const LOGO_URL =
  'https://customer-assets-0z36b82j.emergentagent.net/job_37214009-3d93-4b21-9f01-083558ec430e/artifacts/23blvvft_ChatGPT%20Image%20Sep%2025%2C%202026%20at%2004_35_47%20AM.webp';

export const IMG = {
  // drama / cinematic
  kingdoms: U('photo-1612659513025-fe37f67574d6', 1600),
  kingdomsCard: U('photo-1612659513025-fe37f67574d6', 700),
  headwrap: U('photo-1613876215075-276fd62c89a4', 900),
  blueMoody: U('photo-1534528741775-53994a69daeb', 900),
  maleShadow: 'https://images.pexels.com/photos/29433729/pexels-photo-29433729.png?auto=compress&cs=tinysrgb&w=900',
  manDramatic: U('photo-1587397845856-e6cf49176c70', 800),
  bluePortrait: U('photo-1568038479111-87bf80659645', 800),
  sunsetEpic: U('photo-1547471080-7cc2caa01a7e', 1600),
  goldenHour: U('photo-1516026672322-bc52d61a55d5', 1200),
  baobab: P(15404534),
  orangeDrama: U('photo-1553614186-d23d17be2ad3', 800),
  candle: P(15790324),
  neonStreet: P(15649980),
  neonCity: U('photo-1508179522353-11ba468c4a1c', 800),
  urbanNeon: P(28965748),
  // genres
  ship: U('photo-1590880449155-b54f958ce314', 900),
  ship2: P(2473982),
  couple: U('photo-1591969851586-adbbd4accf81', 800),
  couple2: U('photo-1540076156429-35ffe82b7870', 800),
  kids: U('photo-1528066588405-9e20509b9e34', 800),
  kids2: P(1329305),
  savanna: U('photo-1535941339077-2dd1c7963098', 900),
  wildlife: U('photo-1623951578056-5082d34a9859', 900),
  carChase: U('photo-1617906855223-a69f14c9841d', 800),
  action2: P(6729273),
  comedy: P(9547593),
  comedy2: P(713149),
  cooking: U('photo-1518737003272-dac7c4760d5e', 800),
  corridor: U('photo-1605707471580-101f496794fc', 800),
  lagos: U('photo-1569706971306-de5d78f6418e', 900),
  scifi: U('photo-1674616989478-514d5bc6fefd', 900),
  // podcasts
  pod1: U('photo-1581368135153-a506cf13b1e1', 800),
  pod2: U('photo-1648522168784-067e98df88c0', 800),
  pod3: P(7598553),
  pod4: P(7598549),
  pod5: U('photo-1604277598647-eadc8645952c', 800),
  pod6: U('photo-1569965352022-f014c3ca4c5e', 800),
  pod7: P(8132514),
  pod8: U('photo-1632582204758-5ac65783517a', 800),
  pod9: U('photo-1598488035139-bdbb2231ce04', 800),
  pod10: P(17582115),
  // live
  concert: U('photo-1459749411175-04bf5292ceea', 900),
  concert2: U('photo-1665035212282-3e117d618b36', 900),
  football: U('photo-1629217855633-79a6925d6c47', 900),
  football2: U('photo-1679391029864-d46f366a456b', 900),
  news: U('photo-1581092795360-fd1ca04f0952', 900),
  esports: U('photo-1542751371-adc38448a05e', 900),
  runway: U('photo-1554881070-74595ca2b74c', 900),
  gospel: U('photo-1593678820334-91d5f99be314', 900),
  dj: U('photo-1679746556827-a4722297a613', 900),
};

export const AVATARS = [
  U('photo-1529111290557-82f6d5c6cf85', 200),
  U('photo-1656473031961-9d5d9ee19f40', 200),
  U('photo-1570158268183-d296b2892211', 200),
  U('photo-1632765866070-3fadf25d3d5b', 200),
  U('photo-1518882570151-157128e78fa1', 200),
  U('photo-1527203561188-dae1bc1a417f', 200),
];

export const CREATOR_AVATARS = [
  P(36338866, 300),
  P(31528817, 300),
  P(15135912, 300),
  U('photo-1531901599143-df5010ab9438', 300),
];

export const VIDEO = {
  a: 'https://upload.wikimedia.org/wikipedia/commons/transcoded/c/c0/Big_Buck_Bunny_4K.webm/Big_Buck_Bunny_4K.webm.480p.vp9.webm',
  b: 'https://upload.wikimedia.org/wikipedia/commons/transcoded/a/a2/Elephants_Dream_%282006%29.webm/Elephants_Dream_%282006%29.webm.480p.vp9.webm',
  c: 'https://upload.wikimedia.org/wikipedia/commons/transcoded/f/f1/Sintel_movie_4K.webm/Sintel_movie_4K.webm.480p.vp9.webm',
  d: 'https://upload.wikimedia.org/wikipedia/commons/transcoded/c/cb/Tears_of_Steel_1080p.webm/Tears_of_Steel_1080p.webm.480p.vp9.webm',
  e: 'https://upload.wikimedia.org/wikipedia/commons/transcoded/a/a5/Spring_-_Blender_Open_Movie.webm/Spring_-_Blender_Open_Movie.webm.480p.vp9.webm',
  f: 'https://upload.wikimedia.org/wikipedia/commons/transcoded/7/7a/Charge_-_Blender_Open_Movie-full_movie.webm/Charge_-_Blender_Open_Movie-full_movie.webm.480p.vp9.webm',
};

export const AUDIO = [1, 2, 3, 4, 5, 6, 7, 8].map(
  (n) => `https://www.soundhelix.com/examples/mp3/SoundHelix-Song-${n}.mp3`
);
